const pageData = {
  radioValue: false,
  pageSize: 20,
  pageStyle: 0,
}

export default pageData



// WEBPACK FOOTER //
// ./src/base/pageData.js